// src/components/HomeLoan.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeLoan.css';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";

import { toWords } from "number-to-words";
import Calculator from '../common/calculator';

const HomeLoan = () => {
  const navigate = useNavigate();

  const [emiResult, setEmiResult] = useState(null);
  const [openFormOfEligibility, setOpenFormOfEligibility] = useState(false);
  const [activeLoanTab, setActiveLoanTab] = useState('nationalized');
  const [avtivateTabList, setAvtivateTabList] = useState([]);

  const loanServices = [
    {
      icon: "🏗️",
      title: "Home Construction Loan",
      description: "For building a new house on land you already own. Get financial support to construct your dream home.",
      features: ["Plot valuation included", "Stage-wise disbursement", "Technical guidance available"]
    },
    {
      icon: "🏠",
      title: "Home Extension Loan",
      description: "For expanding or adding to your existing home. Add an annexe, build another floor, or extend your living space.",
      features: ["Flexible repayment options", "Quick approval", "Competitive interest rates"]
    },
    {
      icon: "🛠️",
      title: "Home Improvement Loan",
      description: "For renovating or upgrading your current home. Modernize interiors, fix structural issues, or enhance aesthetics.",
      features: ["Minimal documentation", "No collateral required", "Fast processing"]
    },
    {
      icon: "🌏",
      title: "NRI Home Loan",
      description: "Designed for Non-Resident Indians looking to buy property in India. Special terms and conditions apply.",
      features: ["Repatriation benefits", "Power of attorney facility", "Dedicated NRI support"]
    }
  ];

  const eligibilityCriteria = [
    {
      category: "Age",
      salaried: "21-58 years",
      selfEmployed: "25-65 years"
    },
    {
      category: "Income",
      salaried: "₹10,000/M",
      selfEmployed: "₹2 Lakhs/Y"
    },
    {
      category: "Credit Score",
      salaried: "750+ recommended",
      selfEmployed: "750+ recommended"
    },
    {
      category: "Experience",
      salaried: "2-3 years minimum",
      selfEmployed: "3 years in current field"
    }
  ];

  const requiredDocuments = {
    salaried: [
      "Form 16 - A,B",
      "Employee Job Card",
      "3 to 6 Months Salary Slip",
      "Last 6 Month Bank Statement",
      "Last 3 to 5 years Companies Proof"
    ],
    selfEmployed: [
      "PAN Card",
      "Business Proof",
      "Audited Financial Statements",
      "IT Returns (3 years)",
      "Business Address Proof"
    ],
    nri: [
      "Passport & Visa Copy",
      "Overseas Employment Contract",
      "NRE/NRO Bank Statements",
      "Power of Attorney",
      "Overseas Address Proof"
    ]
  };

  const feesCharges = [
    { name: "Processing Fees", range: "0.25% - 2% of Loan Amount", description: "One-time fee for loan processing" },
    { name: "Legal Charges", range: "Actuals", description: "Property verification and legal formalities" },
    { name: "Stamp Duty", range: "As per State Govt.", description: "Property registration charges" },
    { name: "Technical Charges", range: "₹5,000 - ₹15,000", description: "Property valuation and technical check" },
    { name: "EMI Bounce Charges", range: "₹500 per bounce", description: "Penalty for failed payments" },
    { name: "Prepayment Charges", range: "0-2%", description: "For early loan closure" }
  ];

  const customerReviews = [
    {
      name: "Rohan Gaikwad",
      rating: 4,
      bank: "Home Loan",
      comment: "I received a home loan at 6.90% rate. Being a government employee I was offered low processing fees.",
      loanAmount: "₹20,00,000"
    },
    {
      name: "Jitendra Singh",
      rating: 4,
      bank: "Personal Loan",
      comment: "The comparison feature helped me choose a better option.",
      loanAmount: "₹25,00,000"
    },
    {
      name: "Manoj Jadhav",
      rating: 4,
      bank: "Car Loan",
      comment: "Loan approved in 10 days only which is less compared to other providers. Excellent service!",
      loanAmount: "₹18,00,000"
    },
    {
      name: "Samyak Sancheti",
      rating: 4,
      bank: "Buisness Loan",
      comment: "Used top-up home loan to fund my business during tough times. Life saver!",
      loanAmount: "₹15,00,000"
    }
  ];

  const faqs = [
    {
      question: "What is the maximum loan amount I can get?",
      answer: "Banks generally provide 90-95% of the property agreement value, based on your income eligibility and credit history."
    },
    {
      question: "Can I prepay my home loan?",
      answer: "Yes, you can make full or partial prepayments. Some banks may charge prepayment penalties (0-2%) for early closure."
    },
    {
      question: "Can I apply jointly with family members?",
      answer: "Yes, you can apply jointly with spouse, parents, siblings or close relatives to increase loan eligibility."
    },
    {
      question: "What credit score is required?",
      answer: "A credit score of 750+ is considered good for approval. Higher scores get better interest rates."
    },
    {
      question: "How long does approval take?",
      answer: "Typically 7-15 working days, depending on document verification and property evaluation."
    }
  ];

  // new code start here

  const onSubmit = (e) => {
    e.preventDefault();
  };

  const enquiryFromSubmit = (e) => {
    e.preventDefault();
  };

  const bankListwithNameRate = {
    nationalized: [
      {
        bankName: "Bank of Baroda Home Loan",
        interestRate: "7.45% - 10.2%",
        loanAmount: "₹10L - ₹10Cr",
        emiPerMonth: "₹2,001 - ₹2,135",
        processingFees: "Up to 1% of the loan amount",
        prepaymentCharges: "NIL"
      },
      {
        bankName: "Union Bank of India Home Loan",
        interestRate: "7.45% - 10%",
        loanAmount: "₹5L - ₹2Cr",
        emiPerMonth: "₹2,001 - ₹2,135",
        processingFees: "Up to 1% of the loan amount",
        prepaymentCharges: "Up to 5.5% depending upon scheme and tenure completed"
      },
      {
        bankName: "Indian bank Home Loan",
        interestRate: "7.45% - 10.4%",
        loanAmount: "₹5L - ₹75L",
        emiPerMonth: "₹1,999 - ₹2,144",
        processingFees: "Up to 1% of loan amount",
        prepaymentCharges: "IB Pension Loan Scheme - Up to Rs 25,000- NIL, IB Clean Loan to Salaried - 1.00% on the loan amount"
      },
      {
        bankName: "Punjab & Sind Bank Home Loan",
        interestRate: "7.4% - 10.7%",
        loanAmount: "₹5L - ₹5Cr",
        emiPerMonth: "₹1,999 - ₹2,159",
        processingFees: "Upto 1% of the Loan Amount",
        prepaymentCharges: "NIL"
      },
      {
        bankName: "State Bank of India Home Loan",
        interestRate: "7.25% - 8.45%",
        loanAmount: "₹5L - ₹40Cr",
        emiPerMonth: "₹1,992 - ₹2,049",
        processingFees: "Up to 1% of the loan amount",
        prepaymentCharges: "--"
      },
      {
        bankName: "Punjab National Bank Home Loan",
        interestRate: "7.2% - 10.95%",
        loanAmount: "₹1L - ₹5Cr",
        emiPerMonth: "₹1,990 - ₹2,172",
        processingFees: "Up to 1% of the loan amount",
        prepaymentCharges: "NIL"
      },
      {
        bankName: "Canara Bank Home Loan",
        interestRate: "7.15% - 10%",
        loanAmount: "₹10L - ₹50L",
        emiPerMonth: "₹1,987 - ₹2,125",
        processingFees: "Up to 1% of the loan amount",
        prepaymentCharges: "NIL"
      },
      {
        bankName: "Bank of India Home Loan",
        interestRate: "7.1% - 12.65%",
        loanAmount: "₹5L - ₹7.5Cr",
        emiPerMonth: "₹1,985 - ₹2,257",
        processingFees: "Up to 1% of loan amount + GST",
        prepaymentCharges: "On the floating rate of interest by the individual borrower: No charges. ,On the floating rate of interest by non-individual borrower being applicant or co-applicant: 2% of principal prepaid. ,On the fixed rate of interest by the individual borrower: 3% of principal prepaid; if prepayment is my own source then no fee is applicable."
      },
      {
        bankName: "Bank of Maharashtra Home Loan",
        interestRate: "7.1% - 9.65%",
        loanAmount: "₹10L - ₹2Cr",
        emiPerMonth: "₹1,985 - ₹2,108",
        processingFees: "Up to 1% of loan amount + GST",
        prepaymentCharges: "Documentation Charges - 0.20% of the loan amount + GST"
      }
    ],
    private: [
      {
        bankName: "Reliance Capital Home Loan",
        interestRate: "9.75% - 15%",
        loanAmount: "₹7.5L - ₹3Cr",
        emiPerMonth: "₹2,112 - ₹2,379",
        processingFees: "Upto 5% of the loan amount",
        prepaymentCharges: "--"
      },
      {
        bankName: "YES Bank Home Loan",
        interestRate: "9% - 11.5%",
        loanAmount: "₹10L - ₹10Cr",
        emiPerMonth: "₹2,076 - ₹2,199",
        processingFees: "Up to 1.5% or Rs. 10000 whichever is higher (GST additional)",
        prepaymentCharges: "Allowed if borrower has paid at least 12 EMIs. 20% of principal outstanding (13-24 months of EMI repayment)"
      },
      {
        bankName: "RBL Bank Home Loan",
        interestRate: "9% - 11.55%",
        loanAmount: "₹1L - ₹15Cr",
        emiPerMonth: "₹2,076 - ₹2,202",
        processingFees: "Up to 2% of loan amount",
        prepaymentCharges: "Between 13 to 18 months: 5% of outstanding principal. ,After 18 months: 3% of outstanding principal. , After 12 regular EMIs: NIL"
      },
      {
        bankName: "IDFC FIRST Bank Home Loan",
        interestRate: "8.85% - 10.5%",
        loanAmount: "₹1L - ₹10Cr",
        emiPerMonth: "₹2,069 - ₹2,149",
        processingFees: "Up to 3.5% of the loan amount",
        prepaymentCharges: "Foreclosure charges 5% of the loan amount"
      },
      {
        bankName: "DCB Bank Home Loan",
        interestRate: "8.75% - 14.5%",
        loanAmount: "₹2L - ₹3Cr",
        emiPerMonth: "₹2,064 - ₹2,353",
        processingFees: "Upto 2% of the loan amount",
        prepaymentCharges: "--"
      },
      {
        bankName: "Federal Bank Home Loan",
        interestRate: "8.75% - 12%",
        loanAmount: "₹15L - ₹15Cr",
        emiPerMonth: "₹2,064 - ₹2,224",
        processingFees: "Up to 3% of loan amount",
        prepaymentCharges: "Floating Rate Scheme- NIL, Fixed Rate Scheme (including Byom Loans)- 3%"
      },
      {
        bankName: "ICICI Bank Home Loan",
        interestRate: "8.5% - 11.2%",
        loanAmount: "₹3L - ₹5Cr",
        emiPerMonth: "₹2,052 - ₹2,184",
        processingFees: "Up to 2% of loan amount",
        prepaymentCharges: "NIL for ICICI Home Loans and ICICI Home Improvement Loans with a floating rate of interest., 2% on the outstanding principal on full repayment for ICICI Bank Home Loan with a fixed rate of interest., 2% on the outstanding principal on full repayment for Top Up Loan if the applicant or co-applicant is Non-Individual."
      },
      {
        bankName: "karur Vysya Bank Home Loan",
        interestRate: "8.5% - 10.65%",
        loanAmount: "₹5L - ₹3Cr",
        emiPerMonth: "₹2,052 - ₹2,157",
        processingFees: "Upto 3% of the Loan Amount",
        prepaymentCharges: "--"
      },
      {
        bankName: "Axis Bank Home Loan",
        interestRate: "8.35% - 14%",
        loanAmount: "₹1L - ₹5Cr",
        emiPerMonth: "₹2,044 - ₹2,327",
        processingFees: "Up to 1% of the loan amount or ₹10,000 (whichever is higher) + GST (as applicable)",
        prepaymentCharges: "0 - 2%"
      },
      {
        bankName: "CITI Bank Home Loan",
        interestRate: "8% - 14%",
        loanAmount: "₹1L - ₹5Cr",
        emiPerMonth: "₹2,028 - ₹2,327",
        processingFees: "Up to 3% of the borrowed loan amount",
        prepaymentCharges: "Up to 4% of the outstanding principal plus interest for the ongoing month"
      },
      {
        bankName: "HDFC Bank Home Loan",
        interestRate: "7.9% - 13.2%",
        loanAmount: "₹1L - ₹10Cr",
        emiPerMonth: "₹2,023 - ₹2,286",
        processingFees: "Upto 1.50 % of the Loan amount or upto Rs. 5000/- whichever is higher+ applicable taxes",
        prepaymentCharges: "4% of the outstanding principal (loan tenure between 13 - 24 months), 3% of the outstanding principal (loan tenure between 25 - 36 months), 2% of the outstanding principal (loan tenure if over 36 months)"
      },
      {
        bankName: "Housing Development Finance Corporation Home Loan",
        interestRate: "7.9% - 13.2%",
        loanAmount: "₹1L - ₹1Cr",
        emiPerMonth: "₹2,023 - ₹2,286",
        processingFees: "Up to Rs 4,999",
        prepaymentCharges: "Pre-closure Charges Allowed if borrower has paid at least 12 EMIs"
      },
      {
        bankName: "HDFC Sales Home Loan",
        interestRate: "7.9% - 13.2%",
        loanAmount: "₹5L - ₹10Cr",
        emiPerMonth: "₹2,023 - ₹2,286",
        processingFees: "Up to 1% of the loan amount",
        prepaymentCharges: "--"
      },
      {
        bankName: "Kotak Bank Home Loan",
        interestRate: "7.7% - 13.3%",
        loanAmount: "₹10L - ₹10Cr",
        emiPerMonth: "₹2,013 - ₹2,291",
        processingFees: "Up to 2% of loan amount",
        prepaymentCharges: "0-12 months: Lock-in period 1- 3 years: 4% + GST 3 years onwards: 2% + GST"
      },
      {
        bankName: "HSBC Home Loan",
        interestRate: "7.7% - 12.75%",
        loanAmount: "₹3L - ₹30Cr",
        emiPerMonth: "₹2,013 - ₹2,263",
        processingFees: "Upto 1% of the loan amount sanctioned or INR10,000, whichever is higher",
        prepaymentCharges: "5% within 1 year of tenure,4% within 2 years,3% within 3 years,2 % after 3 years."
      },
    ],
    nbfc: [
      {
        bankName: "DCB Bank Home Loan",
        interestRate: "8.75% - 14.5%",
        loanAmount: "₹2L - ₹3Cr",
        emiPerMonth: "₹2,064 - ₹2,353",
        processingFees: "Upto 2% of the loan amount",
        prepaymentCharges: "--"
      },
      {
        bankName: "Federal Bank Home Loan",
        interestRate: "8.75% - 12%",
        loanAmount: "₹15L - ₹15Cr",
        emiPerMonth: "₹2,064 - ₹2,224",
        processingFees: "Up to 3% of loan amount",
        prepaymentCharges: "Floating Rate Scheme- NIL, Fixed Rate Scheme (including Byom Loans)- 3%"
      },
      {
        bankName: "ICICI Bank Home Loan",
        interestRate: "8.5% - 11.2%",
        loanAmount: "₹3L - ₹5Cr",
        emiPerMonth: "₹2,052 - ₹2,184",
        processingFees: "Up to 2% of loan amount",
        prepaymentCharges: "NIL for ICICI Home Loans and ICICI Home Improvement Loans with a floating rate of interest., 2% on the outstanding principal on full repayment for ICICI Bank Home Loan with a fixed rate of interest., 2% on the outstanding principal on full repayment for Top Up Loan if the applicant or co-applicant is Non-Individual."
      },
      {
        bankName: "karur Vysya Bank Home Loan",
        interestRate: "8.5% - 10.65%",
        loanAmount: "₹5L - ₹3Cr",
        emiPerMonth: "₹2,052 - ₹2,157",
        processingFees: "Upto 3% of the Loan Amount",
        prepaymentCharges: "--"
      },
      {
        bankName: "Axis Bank Home Loan",
        interestRate: "8.35% - 14%",
        loanAmount: "₹1L - ₹5Cr",
        emiPerMonth: "₹2,044 - ₹2,327",
        processingFees: "Up to 1% of the loan amount or ₹10,000 (whichever is higher) + GST (as applicable)",
        prepaymentCharges: "0 - 2%"
      },
      {
        bankName: "CITI Bank Home Loan",
        interestRate: "8% - 14%",
        loanAmount: "₹1L - ₹5Cr",
        emiPerMonth: "₹2,028 - ₹2,327",
        processingFees: "Up to 3% of the borrowed loan amount",
        prepaymentCharges: "Up to 4% of the outstanding principal plus interest for the ongoing month"
      },
      {
        bankName: "HDFC Bank Home Loan",
        interestRate: "7.9% - 13.2%",
        loanAmount: "₹1L - ₹10Cr",
        emiPerMonth: "₹2,023 - ₹2,286",
        processingFees: "Upto 1.50 % of the Loan amount or upto Rs. 5000/- whichever is higher+ applicable taxes",
        prepaymentCharges: "4% of the outstanding principal (loan tenure between 13 - 24 months), 3% of the outstanding principal (loan tenure between 25 - 36 months), 2% of the outstanding principal (loan tenure if over 36 months)"
      },
      {
        bankName: "Housing Development Finance Corporation Home Loan",
        interestRate: "7.9% - 13.2%",
        loanAmount: "₹1L - ₹1Cr",
        emiPerMonth: "₹2,023 - ₹2,286",
        processingFees: "Up to Rs 4,999",
        prepaymentCharges: "Pre-closure Charges Allowed if borrower has paid at least 12 EMIs"
      },
      {
        bankName: "Reliance Capital Home Loan",
        interestRate: "9.75% - 15%",
        loanAmount: "₹7.5L - ₹3Cr",
        emiPerMonth: "₹2,112 - ₹2,379",
        processingFees: "Upto 5% of the loan amount",
        prepaymentCharges: "--"
      },
      {
        bankName: "YES Bank Home Loan",
        interestRate: "9% - 11.5%",
        loanAmount: "₹10L - ₹10Cr",
        emiPerMonth: "₹2,076 - ₹2,199",
        processingFees: "Up to 1.5% or Rs. 10000 whichever is higher (GST additional)",
        prepaymentCharges: "Allowed if borrower has paid at least 12 EMIs. 20% of principal outstanding (13-24 months of EMI repayment)"
      },
      {
        bankName: "RBL Bank Home Loan",
        interestRate: "9% - 11.55%",
        loanAmount: "₹1L - ₹15Cr",
        emiPerMonth: "₹2,076 - ₹2,202",
        processingFees: "Up to 2% of loan amount",
        prepaymentCharges: "Between 13 to 18 months: 5% of outstanding principal. ,After 18 months: 3% of outstanding principal. , After 12 regular EMIs: NIL"
      },
      {
        bankName: "IDFC FIRST Bank Home Loan",
        interestRate: "8.85% - 10.5%",
        loanAmount: "₹1L - ₹10Cr",
        emiPerMonth: "₹2,069 - ₹2,149",
        processingFees: "Up to 3.5% of the loan amount",
        prepaymentCharges: "Foreclosure charges 5% of the loan amount"
      },
      {
        bankName: "HDFC Sales Home Loan",
        interestRate: "7.9% - 13.2%",
        loanAmount: "₹5L - ₹10Cr",
        emiPerMonth: "₹2,023 - ₹2,286",
        processingFees: "Up to 1% of the loan amount",
        prepaymentCharges: "--"
      }
    ]
  }

  const tabChangeLoans = (category) => {
    const list = bankListwithNameRate[category];
    console.log("list", list);
    setActiveLoanTab(category);
    setAvtivateTabList(list);
  }

  const colorSet = [
    { base: "#8EC5FF", hover: "#5FA9FF" },
    { base: "#FF8A8A", hover: "#FF5C5C" },
    { base: "#7FE0B0", hover: "#4FD29A" }
  ];

  const [expandedMap, setExpandedMap] = useState({});

  const toggleExpand = (id) => {
    console.log("chdcking iddd", id)
    setExpandedMap((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const renderCommaSeparated = (text, id) => {
    if (!text || !text.includes(",")) {
      return <span className="value">{text || "NIL"}</span>;
    }

    const items = text.split(",").map((i) => i.trim());

    if (items.length === 1) {
      return (
        <ul className="bullet-list">
          <li>{items[0]}</li>
        </ul>
      );
    }

    const isExpanded = expandedMap[id];

    return (
      <>
        <ul className="bullet-list">
          {(isExpanded ? items : items.slice(0, 1)).map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>

        <button className="more-btn" onClick={() => toggleExpand(id)}>
          {isExpanded ? "Less" : `More`}
        </button>
      </>
    );
  };

  useEffect(() => {
    tabChangeLoans('nationalized');
  }, []);

  const featurelist = [
    {
      title: "Attractive Interest Rates Plan",
      desc: "Home loans are accessible at lower interest rates than other types of loans. Obtaining a home loan is better than going for any other loan type to purchase your dream property. Housing loans are offered at cheap interest rates since the lenders do not want to deal with missed EMIs and unpaid dues"
    },
    {
      title: "Due Diligence Of the Real Estate Property",
      desc: "The finest aspect about housing finance is that the bank will carry it out if you missed out to determine the property’s validity. Furthermore, while evaluating the house loan documentation, bank employees conduct legal checks to verify that the borrower is not defrauded. Due diligence evaluates areas where the bank approves the transaction and alerts you if your property purchase is risky in any aspect."
    },
    {
      title: "Tax Benefits With Housing Loan",
      desc: "People who have mortgages are eligible for income tax benefits. The deduction of income tax is a fantastic benefit of getting a property loan. It is available for the interest paid on a yearly basis. The amount of interest paid is subtracted from the income tax that must be paid."
    },
    {
      title: "Flexible Home Loan Repayment Period",
      desc: "Another feature that distinguishes a home loan from other types of loans is the payback period. You can request longer payback terms whenever it is most convenient for you. One can stretch the loan repayment tenure up to 25 to 30 years. The monthly instalments decrease as the repayment period lengthens, easing the EMI burden on the borrower."
    },
    {
      title: "Availability of Home Loan Balance Transfer",
      desc: "A housing loan allows you to transfer the remaining loan balance from one lender to another. There could be a variety of reasons for this, including interest rates, service fees, an unpleasant customer experience, among others."
    },
    {
      title: "Capital Growth",
      desc: "As per real estate data, the cost of properties has been constantly rising over the last decade. According to analysts, the capital appreciation of the real estate properties is significantly greater as compared to the paid interest amount. It therefore serves as a lucrative opportunity for property owners as now they can sell them for a higher profit."
    }
  ]

  const [activeTabIntrestRate, setActiveTabIntrestRate] = useState("private");

  const bankData = {
    private: [
      "RBL Bank Home Loan Interest Rates",
      "Reliance Capital Home Loan Interest Rates",
      "Deutsche Bank Home Loan Interest Rates",
      "Citi Bank Home Loan Interest Rates",
      "Karnataka Bank Home Loan Interest Rates",
      "IndusInd Bank Home Loan Interest Rates",
      "DCB Bank Home Loan Interest Rates",
      "HSBC Home Loan Interest Rates",
      "Yes Bank Home Loan Interest Rates",
      "Federal Bank Home Loan Interest Rates",
      "HDFC Sales Home Loan Interest Rates",
      "IDFC First Bank Home Loan Interest Rates",
      "IDBI Bank Home Loan Interest Rates",
      "Kotak Mahindra Home Loan Interest Rates",
      "HDFC Bank Home Loan Interest Rates",
      "Axis Bank Home Loan Interest Rates",
      "LIC Housing Finance Home Loan Interest Rates",
      "ICICI Bank Home Loan Interest Rates",
      "HDFC Ltd Home Loan Interest Rates",

    ],
    nbfc: [
      "Ujjivan Small Finance Home Loan Interest Rates",
      "Piramal Finance Home Loan Interest Rates",
      "Tata Capital Housing Finance Home Loan Interest Rates",
      "Poonawalla Fincorp Home Loan Interest Rates",
      "IIFL Finance Home Loan Interest Rates",
      "Hero Housing Finance Home Loan Interest Rates",
      "Hero Fincorp Home Loan Interest Rates",
      "SMFG India Home Loan Interest Rates",
      "Edelweiss Financial Services Home Loan Interest Rates",
      "Home First Finance Home Loan Interest Rates",
      "Godrej Housing Finance Home Loan Interest Rates",
      "Clix Capital Home Loan Interest Rates",
      "Cholamandalam Finance Home Loan Interest Rates",
      "Capri Global Home Loan Interest Rates",
      "Capital First Ltd Home Loan Interest Rates",
      "Aditya Birla Finance Home Loan Interest Rates",
      "L&T Finance Home Loan Interest Rates",
      "DHFL Home Loan Interest Rates",
      "Indiabulls Home Loan Interest Rates",
      "Bajaj Finserv Home Loan Interest Rates",
      "PNB Housing Finance Home Loan Interest Rates",
      "Muthoot Finance Home Loan Interest Rates",
      "Vastu Housing Finance Home Loan Interest Rates",
      "Aadhar Housing Finance Home Loan Interest Rates",
    ],
    nationalised: [
      "SBI Home Loan Interest Rates",
      "Bank of Baroda Home Loan Interest Rates",
      "Punjab National Bank Home Loan Interest Rates",
      "Canara Bank Home Loan Interest Rates",
    ],
  };

  const [activeIndexFaqs, setActiveIndexFaqs] = useState(0);

  const faqData = [
    {
      question: "Is home loan insurance mandatory?",
      answer:
        "Home loan insurance is not mandatory by law, but experts strongly recommend it. It can protect your family from losing their home during unforeseen events when you are unable to make payments.",
    },
    {
      question: "How to check home loan eligibility?",
      answer:
        "You can check home loan eligibility online using bank calculators or by contacting lenders based on your income, age, credit score, and existing liabilities.",
    },
    {
      question: "Can a home loan be transferred to another person?",
      answer:
        "Yes, a home loan can be transferred with lender approval, subject to eligibility checks and legal documentation.",
    },
    {
      question: "Is property insurance mandatory for a home loan?",
      answer:
        "Property insurance is usually required by banks to safeguard the asset against risks such as fire or natural disasters.",
    },
    {
      question: "How to repay home loan faster?",
      answer:
        "You can repay faster by making part-prepayments, increasing EMI amounts, or choosing a shorter loan tenure.",
    },
  ];


  return (
    <div className="homeloan-container">
      {/* Back Button */}
      {/* <button className="homeloan-back-btn" onClick={handleGoBack}>
        ← Back to Home
      </button> */}

      {/* Hero Section with Wave Design */}
      {/* <section className="homeloan-hero-section">
        <div className="homeloan-wave-overlay">
          <div className="homeloan-hero-text">
            <h1>🏠 Make Your Homeownership Dream a Reality!</h1>
            <p className="homeloan-hero-subtitle">Find the perfect home loan with minimal documentation and competitive interest rates</p>
          </div>
        </div>
      </section> */}

      <section className="homeload-main-section homeloan-section">
        <div className='homeloan-eligibility-enquiry-form'>
          <h3>Enquiry Form</h3>
          <form onSubmit={(e) => enquiryFromSubmit(e)} className="homeloan-eligibility-form">
            <div className="homeloan-enquiry-form-group">
              <label>Full Name</label>
              <input type="text" placeholder="Enter Full Name" required />
            </div>
            <div className="homeloan-enquiry-form-group">
              <label>Pan card</label>
              <input type="text" placeholder="Enter Pan card" required />
            </div>
            <div className="homeloan-enquiry-form-group">
              <label>Email Address</label>
              <input type="email" placeholder="Enter Email Address" required />
            </div>
            <div className="homeloan-enquiry-form-group">
              <label>Phone number</label>
              <input type="email" placeholder="Enter Email Address" required />
            </div>
            <div className="homeloan-enquiry-form-group">
              <label>Occupation</label>
              <select>
                <option value="">Select Occupation</option>
                <option value="salaried">Salaried</option>
                <option value="self-employed">Self-Employed</option>
                <option value="partner">Partner</option>
                <option value="proprietor">Proprietor</option>
                <option value="partnership-llp">Partnership/LLP</option>
                <option value="private-limited">Private Limited</option>
                <option value="nri">NRI</option>
              </select>
            </div>
            <div className="homeloan-enquiry-form-group">
              <label>Loan Type</label>
              <select defaultValue="home" disabled>
                <option value="">Select Loan Type</option>
                <option value="home" >Home Loan</option>
                <option value="land">Land Loan</option>
                <option value="construction">Construction Loan</option>
              </select>
            </div>
            <div className="homeloan-enquiry-form-group textarea-group">
              <label>Description</label>
              <textarea type="text" rows={4} placeholder="Enter Description" required />
            </div>
            <button type="submit" className="homeloan-eligibility-enquiry-submit-btn">Check My Eligibility</button>
          </form>
        </div>
        <div className="homeloan-hero-text">
          <h1 className='title'>Realize your Home Dream with our <span>Home Loans!</span></h1>
          <ul>
            <li>Customized Repayment Plans</li>
            <li>Low-Interest Rates</li>
            <li>Expert Guidance</li>
          </ul>
          <p className='subtitle'>
            Make your dream home a reality with our leading home loan services. Urban Money has tied knots with an array of banks providing nimble and hassle-free mortgage loans. Unlock home credit loans with a host of benefits, like low housing loan interest rates and smaller EMIs to space out your payments over a longer tenure.
          </p>
        </div>
      </section>



      {/* Loan Services Section */}
      {/* <section className="homeloan-section homeloan-services-section">
        <div className="homeloan-section-header">
          <span className="homeloan-section-icon">🏠</span>
          <h2>Home Loan Services</h2>
          <p className="homeloan-section-subtitle">Choose from our wide range of home loan products tailored to your needs</p>
        </div>

        <div className="homeloan-services-grid">
          {loanServices.map((service, index) => (
            <div key={index} className="homeloan-service-card">
              <div className="homeloan-service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p className="homeloan-service-description">{service.description}</p>
              <ul className="homeloan-features-list">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="homeloan-check-icon">✓</span> {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section> */}

      {/* <div className='bg-color-homeloan-eligibility'>
        <section className='homeloan-eligibility homeloan-section'>
          <div className="homeloan-eligibility-image">
            <img src="/images/3939.png" alt="Home Loan Eligibility" />
          </div>
          <div className="homeloan-eligibility-text">
            <h2 className='title'>Unlock Best <span>Home Loan Offers</span> From 10+ Lenders</h2>
            <form>
              <div className="homeloan-eligibility-form">
                <div className="homeloan-eligibility-form-group">
                  <label>Required Loan Amount (₹)</label>
                  <input type="number" placeholder="Enter Required Loan Amount" />
                </div>
                <div className="homeloan-eligibility-form-group">
                  <label>Monthly New Salary (₹)</label>
                  <input type="number" placeholder="Enter Monthly New Salary" />
                </div>
                <div className="homeloan-eligibility-form-group">
                  <label>Occupation</label>
                  <select>
                    <option value="">Select Occupation</option>
                    <option value="salaried">Salaried</option>
                    <option value="self-employed">Self-Employed</option>
                    <option value="partner">Partner</option>
                    <option value="proprietor">Proprietor</option>
                    <option value="partnership-llp">Partnership/LLP</option>
                    <option value="private-limited">Private Limited</option>
                    <option value="nri">NRI</option>
                  </select>
                </div>
                <div className="homeloan-eligibility-form-group">
                  <label>City</label>
                  <input type="text" placeholder="Enter City" />
                </div>
                {
                  !openFormOfEligibility &&
                  <button onClick={(e) => {
                    e.preventDefault()
                    setOpenFormOfEligibility(true);
                  }} className="homeloan-eligibility-submit-btn">Next <i className="fas fa-arrow-right" style={{ 'margin-left': '10px' }}></i> </button>
                }
                {
                  openFormOfEligibility &&
                  <>
                    <p className='homeloan-eligibility-form-subtitle'>
                      Just Fill A Few More Details To Get Quote...
                    </p>
                    <div className="homeloan-eligibility-form-group">
                      <label>Full Name</label>
                      <input type="text" placeholder="Enter Full Name" />
                    </div>
                    <div className="homeloan-eligibility-form-group">
                      <label>Phone Number</label>
                      <input type="text" placeholder="Enter Phone Number" />
                    </div>
                    <div className="homeloan-eligibility-form-group">
                      <label>Current Monthly EMIs</label>
                      <input type="text" placeholder="Enter Current Monthly EMIs" />
                    </div>
                    <div className="homeloan-eligibility-form-group">
                      <label>Tenure</label>
                      <input type="text" placeholder="Enter Tenure" />
                    </div>
                    <div className='homeloan-terms-main'>
                      <input type="checkbox" id="terms" name="terms" />
                      <p className='homeloan-terms-condition'>
                        I hereby appoint UrbanMoney as my authorised representative to receive my credit information from CIBIL & agree to receive promotional message from WhatsApp/RCS/SMS. I hereby accept terms & conditions. &nbsp;
                        <a href='#'>Read More.</a>
                      </p>
                    </div>
                    <button onClick={(e) => onSubmit(e)} type="submit" className="homeloan-eligibility-submit-btn">Check Eligibility <i className="fas fa-arrow-right" style={{ 'margin-left': '10px' }}></i> </button>
                  </>
                }
              </div>
            </form>
          </div>
        </section>
      </div> */}


      {/* Eligibility Section */}
      <section className="homeloan-section homeloan-eligibility-section">
        {/* <div className="homeloan-section-header">
          <h2>Eligibility & Documents</h2>
          <p className="homeloan-section-subtitle">Check if you qualify for a home loan and prepare the required documents</p>
        </div> */}

        <div className="homeloan-eligibility-content">
          <div className="homeloan-eligibility-criteria">
            <h3>Eligibility Criteria</h3>
            <div className="homeloan-criteria-table">
              <table>
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Salaried</th>
                    <th>Self-Employed</th>
                  </tr>
                </thead>
                <tbody>
                  {eligibilityCriteria.map((item, index) => (
                    <tr key={index}>
                      <td><strong>{item.category}</strong></td>
                      <td>{item.salaried}</td>
                      <td>{item.selfEmployed}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="homeloan-documents-section">
          <h3>Required Documents</h3>
          <div className="homeloan-documents-grid">
            <div className="homeloan-doc-card">
              <div className="homeloan-doc-header">
                <span>👨‍💼</span>
                <h4>Salaried</h4>
              </div>
              <ul>
                {requiredDocuments.salaried.map((doc, idx) => (
                  <li key={idx}>{doc}</li>
                ))}
              </ul>
            </div>
            <div className="homeloan-doc-card">
              <div className="homeloan-doc-header">
                <span>👨‍💼</span>
                <h4>Self-Employed</h4>
              </div>
              <ul>
                {requiredDocuments.selfEmployed.map((doc, idx) => (
                  <li key={idx}>{doc}</li>
                ))}
              </ul>
            </div>
            <div className="homeloan-doc-card">
              <div className="homeloan-doc-header">
                <span>🌏</span>
                <h4>NRI Applicants</h4>
              </div>
              <ul>
                {requiredDocuments.nri.map((doc, idx) => (
                  <li key={idx}>{doc}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div className='bg-color-homeloan-eligibility'>
        <section className='loan-section-bank homeloan-section'>
          <div className='tab-buttons'>
            <button className={`tab-button ${activeLoanTab === 'nationalized' ? 'active' : ''}`} onClick={() => { tabChangeLoans('nationalized') }}>Nationalized Bank</button>
            <button className={`tab-button ${activeLoanTab === 'private' ? 'active' : ''}`} onClick={() => { tabChangeLoans('private') }}>Private Bank</button>
            <button className={`tab-button ${activeLoanTab === 'nbfc' ? 'active' : ''}`} onClick={() => { tabChangeLoans('nbfc') }}>NBFC</button>
          </div>
          <div className="homeloan-section-header">
            <p className="homeloan-section-subtitle">Top Nationalized Banks For Home Loan -{" "}
              {new Date().toLocaleString("en-US", { month: "long", year: "numeric" })}</p>
          </div>
          {avtivateTabList.map((item, index) => {
            const color = colorSet[index % colorSet.length];

            return (
              <div
                key={index}
                className="loan-card"
                style={{ borderLeft: `5px solid ${color.base}` }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderLeftColor = color.hover)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderLeftColor = color.base)
                }
              >
                <div className="loan-card-header">
                  <div className="bank-info">
                    <span className="bank-icon">🏦</span>
                    <a href="javascript:void(0)" className="bank-name">
                      {item.bankName}
                    </a>
                  </div>

                  <button className="apply-btn">
                    Apply Now →
                  </button>
                </div>

                <div className="loan-details">
                  <div className="detail-item">
                    <span className="label">Interest Rate</span>
                    <span className="value">{item.interestRate}</span>
                  </div>

                  <div className="detail-item">
                    <span className="label">Loan Amount</span>
                    <span className="value">{item.loanAmount}</span>
                  </div>

                  <div className="detail-item">
                    <span className="label">EMI Per Lakh</span>
                    <span className="value">{item.emiPerMonth}</span>
                  </div>

                  <div className="detail-item">
                    <span className="label">Processing Fees</span>
                    <span className="value">{item.processingFees}</span>
                  </div>

                  <div className="detail-item">
                    <span className="label">Pre-Payment Charges</span>
                    {renderCommaSeparated(
                      item.prepaymentCharges,
                      `prepayment-${index}`
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </section>
      </div>


      <section className='homeloan-section homeloan-emi-calculator'>
        <h2>Calculate Your Home Loan EMI Online</h2>

        <Calculator />
        {/* <div className="schedule">
          <div
            className="schedule-header"
            onClick={() => setShowSchedule(!showSchedule)}
          >
            <h3>EMI Payment Schedule</h3>
            <span>{showSchedule ? "▲" : "▼"}</span>
          </div>

          {showSchedule && (
            <table>
              <thead>
                <tr>
                  <th>Month</th>
                  <th>Principal</th>
                  <th>Interest</th>
                  <th>Total Payment</th>
                  <th>Balance</th>
                </tr>
              </thead>

              <tbody>
                {schedule.map((row) => (
                  <tr key={row.month}>
                    <td>{row.month}</td>
                    <td>₹{row.principal.toFixed(0)}</td>
                    <td>₹{row.interest.toFixed(0)}</td>
                    <td>₹{row.emi.toFixed(0)}</td>
                    <td>₹{row.balance.toFixed(0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div> */}
      </section>

      {/* EMI Calculator Section */}
      {/* <section className="homeloan-section homeloan-emi-section">
        <div className="homeloan-section-header">
          <span className="homeloan-section-icon">🧮</span>
          <h2>EMI Calculator</h2>
          <p className="homeloan-section-subtitle">Calculate your monthly EMI and plan your home loan effectively</p>
        </div>

        <div className="homeloan-emi-calculator">
          <div className="homeloan-calculator-container">
            <div className="homeloan-calculator-inputs">
              <div className="homeloan-input-group">
                <label>
                  <span className="homeloan-input-icon">💰</span>
                  Loan Amount (₹)
                </label>
                <input
                  type="range"
                  min="500000"
                  max="5000000"
                  step="50000"
                  value={emiData.loanAmount}
                  onChange={(e) => setEmiData({ ...emiData, loanAmount: parseInt(e.target.value) })}
                />
                <div className="homeloan-value-display">₹ {emiData.loanAmount.toLocaleString('en-IN')}</div>
              </div>

              <div className="homeloan-input-group">
                <label>
                  <span className="homeloan-input-icon">📊</span>
                  Interest Rate (% p.a.)
                </label>
                <input
                  type="range"
                  min="6.5"
                  max="12"
                  step="0.1"
                  value={emiData.interestRate}
                  onChange={(e) => setEmiData({ ...emiData, interestRate: parseFloat(e.target.value) })}
                />
                <div className="homeloan-value-display">{emiData.interestRate}%</div>
              </div>

              <div className="homeloan-input-group">
                <label>
                  <span className="homeloan-input-icon">⏳</span>
                  Loan Tenure (Years)
                </label>
                <input
                  type="range"
                  min="5"
                  max="30"
                  step="1"
                  value={emiData.tenure}
                  onChange={(e) => setEmiData({ ...emiData, tenure: parseInt(e.target.value) })}
                />
                <div className="homeloan-value-display">{emiData.tenure} Years</div>
              </div>
            </div>

            {emiResult && (
              <div className="homeloan-emi-result">
                <div className="homeloan-result-card homeloan-main-result">
                  <div className="homeloan-result-label">Monthly EMI</div>
                  <div className="homeloan-emi-amount">₹ {emiResult.emi.toLocaleString('en-IN')}</div>
                  <div className="homeloan-result-note">Per month for {emiData.tenure * 12} months</div>
                </div>
                <div className="homeloan-result-details">
                  <div className="homeloan-detail-item">
                    <span>Principal Amount</span>
                    <span className="homeloan-detail-value">₹ {emiResult.principal.toLocaleString('en-IN')}</span>
                  </div>
                  <div className="homeloan-detail-item">
                    <span>Interest Payable</span>
                    <span className="homeloan-detail-value">₹ {emiResult.interestPayable.toLocaleString('en-IN')}</span>
                  </div>
                  <div className="homeloan-detail-item homeloan-total">
                    <span>Total Amount Payable</span>
                    <span className="homeloan-detail-value homeloan-total-value">₹ {emiResult.totalAmount.toLocaleString('en-IN')}</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="homeloan-emi-breakup">
            <h3>📊 Payment Breakup</h3>
            <div className="homeloan-breakup-chart">
              <div className="homeloan-chart-visual">
                <div
                  className="homeloan-principal-chart"
                  style={{ width: `${(emiResult?.principal / emiResult?.totalAmount * 100)}%` }}
                  title={`Principal: ₹${emiResult?.principal.toLocaleString('en-IN')}`}
                >
                  <span className="homeloan-chart-label">Principal</span>
                  <span className="homeloan-chart-percentage">
                    {(emiResult?.principal / emiResult?.totalAmount * 100).toFixed(1)}%
                  </span>
                </div>
                <div
                  className="homeloan-interest-chart"
                  style={{ width: `${(emiResult?.interestPayable / emiResult?.totalAmount * 100)}%` }}
                  title={`Interest: ₹${emiResult?.interestPayable.toLocaleString('en-IN')}`}
                >
                  <span className="homeloan-chart-label">Interest</span>
                  <span className="homeloan-chart-percentage">
                    {(emiResult?.interestPayable / emiResult?.totalAmount * 100).toFixed(1)}%
                  </span>
                </div>
              </div>
              <div className="homeloan-chart-legend">
                <div className="homeloan-legend-item">
                  <div className="homeloan-legend-color homeloan-principal"></div>
                  <div className="homeloan-legend-text">
                    <span className="homeloan-legend-title">Principal Amount</span>
                    <span className="homeloan-legend-value">₹ {emiResult?.principal.toLocaleString('en-IN')}</span>
                  </div>
                </div>
                <div className="homeloan-legend-item">
                  <div className="homeloan-legend-color homeloan-interest"></div>
                  <div className="homeloan-legend-text">
                    <span className="homeloan-legend-title">Interest Amount</span>
                    <span className="homeloan-legend-value">₹ {emiResult?.interestPayable.toLocaleString('en-IN')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Fees & Charges Section */}
      {/* <section className="homeloan-section homeloan-fees-section">
        <div className="homeloan-section-header">
          <span className="homeloan-section-icon">💰</span>
          <h2>Fees & Charges</h2>
          <p className="homeloan-section-subtitle">Transparent fee structure with no hidden costs</p>
        </div>

        <div className="homeloan-fees-grid">
          {feesCharges.map((fee, index) => (
            <div key={index} className="homeloan-fee-card">
              <h3>{fee.name}</h3>
              <div className="homeloan-fee-range">{fee.range}</div>
              <p className="homeloan-fee-description">{fee.description}</p>
            </div>
          ))}
        </div>
      </section> */}

      {/* sticky header ======================= */}
      <div class="hp-sticky-wrapper">
        <div class="hp-sticky-inner">
          <div class="hp-nav">
            <a href="#feature-benefits" class="hp-link active">Features & Benefits</a>
            <a href="#eligibility-criteria" class="hp-link">Eligibility Criteria</a>
            <a href="#interest-rate" class="hp-link">Interest Rates</a>
            <a href="#" class="hp-link">FAQs</a>
            <a href="#" class="hp-apply-btn">Apply Now</a>
          </div>
        </div>
      </div>

      <div className='homeloan-section sticky-content' id='feature-benefits'>
        <div className='hp-content' >
          <h3>
            Home Loan Features and Benefits
          </h3>
          <p className='desc'>Home loan offers numerous benefits to the borrower including lower interest rates, tax benefits, flexible repayment time frame and much more.</p>
          <div>
            {
              featurelist.map((item, index) => (
                <div key={index} className='hp-feature-item'>
                  <h4> {index + 1} .  {item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              ))
            }
          </div>
          <h3>
            Home Loan Tax Benefits
          </h3>
          <p className='desc'>The repayment of a home loan consists of two parts: repayment of the principal amount and the interest rate. When filing income tax returns, these parts are claimed as a home loan interest deduction or a tax deduction.</p>
          <p className='desc'>
            Section 80 EEA allows you to claim tax benefits for the interest component paid on a house loan. This part offers house loan borrowers tax incentives of up to INR 1.5 lakhs on the interest rate they must pay.
          </p>
          <table border="1">
            <thead>
              <tr>
                <th>Particulars</th>
                <th>Quantum Of Amount Deduction</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Under Section 24</td>
                <td><strong>A.</strong> For self-occupied property: Rs. 2,00,000 <br />
                  <strong>B.</strong> For non-self occupied property: No set limit</td>
              </tr>
              <tr>
                <td>Under Section 80 C</td>
                <td><strong>A.</strong> For self-occupied property: Rs. 1.5 Lakhs
                  <br />
                  <strong>B.</strong> For non-self-occupied property: Rs. 1.5 Lakhs</td>
              </tr>
              <tr>
                <td>Under Section 80 EEA</td>
                <td><strong>A.</strong> For self-occupied property: Rs. 1.5 Lakhs
                  <br />
                  <strong>B.</strong> For non-self-occupied property: Rs. 1.5 Lakhs</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className='hp-content' id='eligibility-criteria'>
          <h3>
            Home Loan Eligibility Criteria
          </h3>
          <p className='desc'>Banks and finance companies have pre-determined home loan eligibility criteria to verify and provide maximum ease to loan borrowers. Apart from the eligibility criteria, banks look at the applicant’s credit history to establish creditworthiness and repayment patterns</p>
          <ul className='home-construction-loan-ul'>
            <li>Applicant must be between 21 to 65 years</li>
            <li>Salaried or self employed</li>
            <li>Annual income</li>
            <li>Collateral security</li>
            <li>Assets, financial stability and occupational continuity</li>
            <li>Residence status (Indian or NRI)</li>
          </ul>
        </div>
        <div className='hp-content' id='interest-rate'>
          <h3>
            Home Loan Interest Rates
          </h3>
          <p className='desc'>Housing loan interest rates play a crucial role in determining the affordability of your dream home. So, To make an informed decision, it’s essential to compare the housing loan interest rates of all banks and financial institutions with each other. These rates, which vary among lenders, are usually influenced by many factors such as your credit score, home loan tenure, loan amount, and each lender’s policies. A lower interest rate will lower your monthly EMIs and total cost of your loan, making homeownership more affordable. With many lenders offering competitive interest rates, researching and comparing housing loan interest rates of all banks can help you secure the best deal, ensuring that your dream home doesn’t become a financial burden.
          </p>
          <div className='intrest-rates-card'>
            <h4>Home Loan Interest Rates offered by Different Banks</h4>
            <div className='interest-rates-table'>
              <div className="bank-tabs-wrapper">
                {/* Tabs */}
                <div className="bank-tabs">
                  <button
                    className={`bank-tab ${activeTabIntrestRate === "private" ? "active" : ""}`}
                    onClick={() => setActiveTabIntrestRate("private")}
                  >
                    From Private Banks
                  </button>

                  <button
                    className={`bank-tab ${activeTabIntrestRate === "nbfc" ? "active" : ""}`}
                    onClick={() => setActiveTabIntrestRate("nbfc")}
                  >
                    From NBFCs
                  </button>

                  <button
                    className={`bank-tab ${activeTabIntrestRate === "nationalised" ? "active" : ""
                      }`}
                    onClick={() => setActiveTabIntrestRate("nationalised")}
                  >
                    From Nationalised Banks
                  </button>
                </div>

                {/* Content */}
                <div className="bank-list-container">
                  <div className="bank-list">
                    {bankData[activeTabIntrestRate].map((item, index) => (
                      <a key={index} href="#" className="bank-item">
                        {item.split(" ").length > 6
                          ? item.split(" ").slice(0, 6).join(" ") + "..."
                          : item}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className='hp-content' id='faqs'>
          <h3>FAQs</h3>
          <p className='desc'>From loans to affordable interest rates, we have the answers for everything you need to know.</p>
        </div> */}

      </div>


      {/* Customer Reviews Section */}
      <section className="homeloan-section homeloan-reviews-section">
        <div className="homeloan-section-header">
          <span className="homeloan-section-icon">⭐</span>
          <h2>Customer Reviews</h2>
          <p className="homeloan-section-subtitle">What our customers say about their home loan experience</p>
        </div>

        <div className="homeloan-reviews-grid">
          {customerReviews.map((review, index) => (
            <div key={index} className="homeloan-review-card">
              <div className="homeloan-review-header">
                <div className="homeloan-reviewer-avatar">
                  {review.name.charAt(0)}
                </div>
                <div className="homeloan-reviewer-info">
                  <h4>{review.name}</h4>
                  <div className="homeloan-review-bank">{review.bank}</div>
                </div>
                <div className="homeloan-review-rating">
                  {'★'.repeat(review.rating)}{'☆'.repeat(5 - review.rating)}
                </div>
              </div>
              <p className="homeloan-review-content">{review.comment}</p>
              <div className="homeloan-review-footer">
                <div className="homeloan-loan-amount">{review.loanAmount}</div>
                <div className="homeloan-verified-badge">✓ Verified Customer</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="homeloan-section homeloan-faq-section">
        <div className="homeloan-section-header">
          <span className="homeloan-section-icon">❓</span>
          <h2>Frequently Asked Questions</h2>
          <p className="homeloan-section-subtitle">Get answers to common questions about home loans</p>
        </div>

        <div className="homeloan-faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="homeloan-faq-item">
              <div className="homeloan-faq-question">
                <span className="homeloan-q-icon">Q:</span>
                <h4>{faq.question}</h4>
              </div>
              <div className="homeloan-faq-answer">
                <span className="homeloan-a-icon">A:</span>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="homeloan-cta-section">
        <div className="homeloan-cta-content">
          <h2>Ready to Start Your Home Loan Journey?</h2>
          <p>Apply online in just 5 minutes and get instant approval</p>
          <div className="homeloan-cta-buttons">
            <button className="homeloan-cta-primary">Apply Now →</button>
            <button className="homeloan-cta-secondary">Speak with Expert</button>
          </div>
          <div className="homeloan-cta-features">
            <div className="homeloan-cta-feature">
              <span>📞</span>
              <div>
                <h4>Call Us</h4>
                <p>9909002220</p>
              </div>
            </div>
            <div className="homeloan-cta-feature">
              <span>📧</span>
              <div>
                <h4>Email Us</h4>
                <p>info@kfs09.in</p>
              </div>
            </div>
            <div className="homeloan-cta-feature">
              <span>⏰</span>
              <div>
                <h4>Support Hours</h4>
                <p>Mon-Sat: 9AM-7PM</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Footer */}
      {/* <footer className="homeloan-page-footer">
        <p>© 2024 Home Loan Services. All rights reserved.</p>
        <p>Powered by Krishna Finconcept Services</p>
      </footer> */}
    </div>
  );
};

export default HomeLoan;